import React, { Component } from "react";
import { connect } from "react-redux";
import { AvForm, AvField } from "availity-reactstrap-validation";

import {
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
  Label,
} from "reactstrap";
import {
  InputChangeValue,
  MenuAdd,
  model_open,
  model_close,
} from "../../../store/Masters/Menus/actions";

class AddMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.ChangeHandeler = this.ChangeHandeler.bind(this);
    this.handleValidSubmit = this.handleValidSubmit.bind(this);
  }
  ChangeHandeler(e) {
    this.props.InputChangeValue({
      key: e.target.name,
      value: e.target.value,
    });
  }
  handleValidSubmit() {
    var data = this.props.rowdata;

    if (data.name == null) {
      // var errorSubLoc = "Enter Location";
    } else {
      var values = {
        id: data.id,
        name: data.name,
        location_id: data.location_id,
      };

      this.props.MenuAdd(values);
    }
  }
  render() {
    var data = this.props.rowdata;
    return (
      <React.Fragment>
        <Modal isOpen={this.props.model} backdrop="static" centered size="lg">
          <ModalHeader toggle={() => this.props.model_close()}>
            ADD Menu
          </ModalHeader>
          <AvForm
            className="form-horizontal"
            onValidSubmit={this.handleValidSubmit}
          >
            <ModalBody>
              <Row className="justify-content-center">
                <Col md={10}>
                  <Row className="justify-content-center">
                    <Col md={9}>
                      <FormGroup row>
                        <Col md={4}>
                          <Label
                            htmlFor="LocationName"
                            className="col-form-label float-right"
                          >
                            Menu Name
                          </Label>
                        </Col>
                        <Col md={8}>
                          <AvField
                            name="name"
                            type="text"
                            value={data.name}
                            onChange={this.ChangeHandeler}
                            className="form-control"
                            id="LocationName"
                            placeholder="Enter Location Name"
                            errormessage=" Please provide a valid Location Name"
                            validate={{ required: { value: true } }}
                          />
                        </Col>
                      </FormGroup>
                      <FormGroup>
                        <AvField
                          className="form-control"
                          type="hidden"
                          value={data.id}
                          id="id"
                          name="id"
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                </Col>
              </Row>

              <ModalFooter>
                <Button
                  type="button"
                  className="btn btn-danger"
                  color="light"
                  onClick={() => this.props.model_close()}
                >
                  Close
                </Button>
                <Button
                  type="submit"
                  className="btn btn-primary"
                  color="primary"
                >
                  Save
                </Button>
              </ModalFooter>
            </ModalBody>
          </AvForm>
        </Modal>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => {
  const { model, rowdata } = state.Menus;
  return { model, rowdata };
};

export default connect(mapStatetoProps, {
  InputChangeValue,
  MenuAdd,

  model_open,
  model_close,
})(AddMenu);
